export default {
  mediaCollections: JSON.parse(localStorage.getItem("mediaCollections")) || [],
  user: JSON.parse(localStorage.getItem("user")) || null,
  listMedias: 0,
  mediasLikedByUser: [],
};
